/* ========== import tool ========== */
import queryString from "query-string";
import axios from "axios";
import ApiUrls from "../../../api/project/ApiUrls";

export const singleImportFile = ({ files, filename, token, pattern, user }) =>
  new Promise((resolve, reject) => {
    if (!pattern) resolve("pattern is required");
    const { displayName, email } = user;

    const queryObj = {};
    if (filename) {
      queryObj.filename = filename;
    }
    const queryStr = queryString.stringify(queryObj);
    // pattern: hsna_sna (專案_類別)
    const url = `${ApiUrls.postSingleImportFile().replace(
      "{pattern}",
      pattern
    )}?${queryStr}`;

    if (!url) resolve(null);

    const formData = new FormData();

    // ※formData 要放的是 file 物件不是字串
    files.forEach((file) => {
      formData.append("file", file);
    });
    formData.append("userName", displayName);
    formData.append("userEmail", email);
    if (filename) {
      formData.append("filename", "5eb63bbbe01eeed093cb22bb8f5acdc3.xlsx ");
      // formData.append("filename", filename);
    }

    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        const customErr = new Error("檔案上傳失敗");
        reject(customErr);
      });
  });
